import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@mui/material/IconButton';
import markerStyleProximity from '../../1elements/Icons/js/mapIcons/style/markerStyle-proximity';
import markerStylePin from '../../1elements/Icons/js/mapIcons/style/markerStyle-pin';
import markerStyleFlag from '../../1elements/Icons/js/mapIcons/style/markerStyle-flag';
import markerStyleCircle from '../../1elements/Icons/js/mapIcons/style/markerStyle-circle';
import Paper from '@mui/material/Paper';

const MarkerStyleSelector = ({ options, selectedRow, setOptions, updateMarker }) => {
  const classes = useStyles();
  const styleList = [
    { name: 'default', svg: markerStyleProximity },
    { name: 'pin', svg: markerStylePin },
    { name: 'circle', svg: markerStyleCircle },
    { name: 'flag', svg: markerStyleFlag }
  ];

  const updateStyle = (style) => {
    if (setOptions) {
      setOptions((prevState) => ({
        ...prevState,
        [selectedRow]: { ...prevState[selectedRow], style }
      }));
    }
    if (typeof updateMarker === 'function') {
      updateMarker({ style });
    }
  };

  return (
    <Paper className={classes.root}>
      {styleList.map((style, index) => (
        <IconButton
          key={index}
          aria-label={`Use ${style.name} marker shape`}
          onClick={() => updateStyle(style.name)}
          className={
            style.name === options[selectedRow]?.style
              ? classes.selected
              : classes.notSelected
          }
        >
          <img alt="" src={style.svg('grey')} />
        </IconButton>
      ))}
    </Paper>
  );
};

export default MarkerStyleSelector;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 40,
    maxWidth: 260,
    padding: 30,
    borderRadius: 22
  },
  selected: {
    border: `3px solid ${theme.palette.primary.main} !important`
  },
  notSelected: {
    border: `3px solid ${theme.palette.quaternary.main} !important`
  }
}));
